import pkg from "../../../package.json";

export const ENVIRONMENTS = {
	develop: {
		production: false,
		apiUrl: "/api/jstore/v1/",
		api_url: "https://dev.jeanologia.com:8000",
		login_url: "https://dev.jeanologia.com:3000",
		url_requests: "https://dev.jeanologia.com:8000/v2/create-requests",
		url_collab_requests: "https://dev.jeanologia.com:8000/v2/create-requests-lite",
		cdnEndpoint: "",
		landingUrl: "",
		debug: {
			network: true,
		},
		clientId: null,
		loginServer: null,
		business_central_baseUrl: "https://kw18-cloud.ekon.es/karat/services/M793SQL/m793_clientes/getClientes?empresa=JEA&clientes=",
		currentAdminToolkey: "adminTool",
		currentAdminClientkey: "adminTool",
		azureVariables: {
			url: "https://jeanologia01.blob.core.windows.net/",
		},
		version: pkg.version,
		idApp: "5dde31fbf92648254b67be2a",
		superUser: "6225f4a2980cb0489375b43c",
		idCloudProduct: "60ab7087d300d9be4f5df040"
	},
	test: {
		production: true,
		api_url: "https://apitest.jeanologia.com",
		login_url: "https://logintest.jeanologia.com",
		url_requests: "https://apitest.jeanologia.com/v2/create-requests",
		url_collab_requests: "https://apitest.jeanologia.com/v2/create-requests-lite",
		apiToken: "12154ef364f9933033ba9824b2c8894b",
		cdnEndpoint: "https://jeanologia-cdn01.azureedge.net/fronts/marketplace/v" + (pkg as any).version + "/",
		landingUrl: "",
		debug: {
			network: false,
		},
		clientId: null,
		loginServer: null,
		business_central_baseUrl: "https://kw18-cloud.ekon.es/karat/services/M793SQL/m793_clientes/getClientes?empresa=JEA&clientes=",
		currentAdminToolkey: "adminTool",
		currentAdminClientkey: "adminTool",
		azureVariables: {
			url: "https://jeanologia01.blob.core.windows.net/",
		},
		version: pkg.version,
		idApp: "5defc6de524732b4d8f16e6a",
		superUser: "6225f4a2980cb0489375b43c",
		idCloudProduct: "60ab7087d300d9be4f5df040"
	},
	production: {
		production: true,
		apiUrl: "/api/jstore/v1/",
		api_url: "https://api.jeanologia.com",
		login_url: "https://login.jeanologia.com",
		url_requests: "https://api.jeanologia.com/v2/create-requests",
		url_collab_requests: "https://api.jeanologia.com/v2/create-requests-lite",
		apiToken: "12154ef364f9933033ba9824b2c8894b",
		cdnEndpoint: "https://jeanologia-cdn01.azureedge.net/fronts/marketplace/v" + pkg.version + "/",
		landingUrl: "",
		debug: {
			network: false,
		},
		clientId: null,
		loginServer: null,
		business_central_baseUrl: "https://kw18-cloud.ekon.es/karat/services/M793EKON/m793_clientes/getClientes?empresa=JEA&clientes=",
		currentAdminToolkey: "adminTool",
		currentAdminClientkey: "adminTool",
		azureVariables: {
			url: "https://marketplacestg1.blob.core.windows.net/",
		},
		version: pkg.version,
		idApp: "5dde31fbf92648254b67be2a",
		superUser: "6225f4a2980cb0489375b43c",
		idCloudProduct: "677fe327f3e974c402fe1ab5"
	},
};
